module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b6b18f1524eedba8ac881ab30c0ca546.png";